"use client";

import dynamic from "next/dynamic";
import type {
  GreenLineAecomCorridors,
  GreenLineAecomOption,
} from "@/app/transit/_lib/data";

// MapLibre + deck.gl touch `window`/`document` at module load and cannot run
// during SSR. `dynamic(..., { ssr: false })` is only legal from a "use client"
// boundary in the App Router; this thin host is that boundary, keeping the
// alignment page itself a server component and the map JS out of the initial
// response. Mirrors /cycling NetworkMapHost.
const AecomCorridorMap = dynamic(() => import("./AecomCorridorMap"), {
  ssr: false,
  loading: () => (
    <div
      className="relative w-full bg-bg-2 border border-rule-2 rounded overflow-hidden"
      style={{ aspectRatio: "940 / 620" }}
    >
      <div className="absolute inset-0 grid place-items-center pointer-events-none">
        <div className="cs-mono text-xs text-ink-3">loading map…</div>
      </div>
    </div>
  ),
});

export function AecomCorridorMapHost({
  corridors,
  options,
}: {
  corridors: GreenLineAecomCorridors;
  options: GreenLineAecomOption[];
}) {
  return <AecomCorridorMap corridors={corridors} options={options} />;
}
